export default __webpack_public_path__ + "static/media/check_white.e62d5e3f.svg";